var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error)?_c('div',[_vm._v(" "+_vm._s(_vm.error)+" ")]):(_vm.pending)?_c('div',[_vm._v(" "+_vm._s(_vm.$t('pendingMessage'))+" ")]):_c('div',[_c('h3',[_vm._v(_vm._s(_vm.$t('uploadFile')))]),_c('input',{attrs:{"id":"portfolio-field","type":"file","accept":".json"},on:{"change":_vm.onFileChanged}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }